import React, { FC, useContext, useState } from 'react';

import { ImageRenderer } from '@src/atoms/ImageRenderer';
import { DATA_ELEM_ZOOM_PREVIEW } from '../consts';
import { Text } from '@src/atoms/Text';
import { Box } from '@src/atoms/Box';
import { classnames } from '@src/utils/classnames';
import { Loader } from '../../Loader';
import { IWithStylesProps } from '@src/models/props';
import { IMediaFile } from '@src/models/api';
import { getIsImage } from '../utils';
import { ZoomFileName } from '../_FileName/ZoomFileName';
import { BreakpointsContext } from '@centra/ui-global-context';

import styles from './ZoomPreview.module.scss';

export interface IPreviewProps extends IWithStylesProps {
  file: IMediaFile;
  isFileNameShown?: boolean;
  isActive?: boolean;
  onClose: () => void;
}

/** Компонент выполняет предзагрузку изображение, а также показывает лоудер в процессе загрузки или неудачи */
export const ZoomPreview: FC<IPreviewProps> = ({ className, isFileNameShown, style, isActive, file, onClose }) => {
  const { isMobile } = useContext(BreakpointsContext);
  const [loaded, setLoaded] = useState(false);

  const isImage = getIsImage(file);
  const classes = classnames(styles.root, className, !isMobile && styles.rootDesktop);
  const imageClasses = classnames(loaded && styles.imageHidden);
  const isFileName =
    isFileNameShown && isImage && (isActive || !isMobile) && (file.originalName || file.originalName !== 'undefined');

  const handleClose = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <Box onClick={handleClose} fullWidth alignItems="center" justifyContent="center">
      <Box data-elem={DATA_ELEM_ZOOM_PREVIEW} className={classes} style={style} gap={4} column alignItems={'center'}>
        {isFileName && <ZoomFileName fileName={file.originalName} />}

        {loaded && (
          <Box style={{ minHeight: 300 }} alignItems="center" justifyContent="center">
            <Loader size={50} className={styles.loader} />
          </Box>
        )}

        {isImage ? (
          <ImageRenderer
            className={imageClasses}
            onLoad={() => setLoaded(true)}
            onLoaded={() => setLoaded(false)}
            url={file.mainUrl || file.previewUrl}
            fit={'contain'}
            uploadImmediately
          />
        ) : (
          file.previewUrl && (
            <Box justifyContent={'center'} alignItems={'center'} className={styles.noPreviewContainer} column>
              <Box className={styles.iconContainer}>
                <ImageRenderer
                  url={file.previewUrl}
                  onLoad={() => setLoaded(true)}
                  onLoaded={() => setLoaded(false)}
                  uploadImmediately
                />
              </Box>
              <Text id={'noPreviewText'} color={'basicWhite'} weight={'bold'}>
                Превью файла недоступно
              </Text>
              <Text id={'fileOriginalNameNoPreviewText'} color={'basicWhite'}>
                {file.originalName}
              </Text>
            </Box>
          )
        )}
      </Box>
    </Box>
  );
};
